/**
 * P5-01: Toast 桥接。
 *
 * 旧实现：js/ui.js:displayAutosave 与 game.js:saveUI 直接操作
 * #autosaveTooltip / #saveTooltip 的 opacity 动画。
 * P5 将这两个提示迁到 React TopBar，引擎通过本桥接触发提示。
 *
 * 设计：单一 listener 模式（同时只会有一个 TopBar 挂载），未挂载时
 * showToast 为 no-op。listener 返回取消函数用于清理。
 */

export type ToastType = "autosave" | "save";
export type ToastListener = (type: ToastType) => void;

let listener: ToastListener | null = null;

export function setToastListener(l: ToastListener | null): void {
  listener = l;
}

export function showToast(type: ToastType): void {
  listener?.(type);
}

export function showAutosaveToast(): void {
  showToast("autosave");
}

export function showSaveToast(): void {
  showToast("save");
}
